var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChipDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.94409 4.4999L7.66143 1.78256C7.71047 1.7352 7.74958 1.67855 7.77648 1.61592C7.80339 1.55328 7.81755 1.48591 7.81814 1.41775C7.81874 1.34958 7.80575 1.28198 7.77993 1.21889C7.75412 1.15579 7.716 1.09847 7.6678 1.05027C7.61959 1.00207 7.56227 0.963946 7.49918 0.938132C7.43609 0.912319 7.36848 0.899329 7.30032 0.899922C7.23215 0.900514 7.16478 0.914676 7.10215 0.941582C7.03952 0.968488 6.98287 1.0076 6.93551 1.05663L4.21816 3.77398L1.50082 1.05663C1.40399 0.963116 1.27431 0.911369 1.1397 0.912539C1.0051 0.913708 0.876334 0.967701 0.781148 1.06289C0.685962 1.15807 0.63197 1.28684 0.6308 1.42144C0.629631 1.55605 0.681377 1.68573 0.774894 1.78256L3.49224 4.4999L0.774894 7.21725C0.725861 7.2646 0.68675 7.32125 0.659844 7.38389C0.632938 7.44652 0.618776 7.51389 0.618183 7.58206C0.617591 7.65022 0.63058 7.71782 0.656394 7.78092C0.682207 7.84401 0.720328 7.90133 0.768531 7.94953C0.816734 7.99774 0.874054 8.03586 0.937147 8.06167C1.00024 8.08749 1.06784 8.10048 1.13601 8.09988C1.20418 8.09929 1.27154 8.08513 1.33418 8.05822C1.39681 8.03132 1.45346 7.99221 1.50082 7.94317L4.21816 5.22583L6.93551 7.94317C7.03233 8.03669 7.16201 8.08844 7.29662 8.08727C7.43123 8.0861 7.55999 8.0321 7.65518 7.93692C7.75037 7.84173 7.80436 7.71297 7.80553 7.57836C7.8067 7.44375 7.75495 7.31407 7.66143 7.21725L4.94409 4.4999Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipDeleteIcon);
export default __webpack_public_path__ + "static/media/chip-delete-icon.56e2ce49ceb851b6678eb045308b7b5c.svg";
export { ForwardRef as ReactComponent };